import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { TTableProps } from './types/index.types';
import { TableModel } from './models/index.model';
import TableComp from './components/table';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const Table = (props: TTableProps) => {
  const model = new TableModel(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  if (!model) return null;
  return (
    <AnalyticsVisibleEvent
      rendering={props?.rendering}
      title={model.heading?.value}
      template="Table"
      className="model-specifications-table-analytics-wrapper"
    >
      <TableComp model={model} />
    </AnalyticsVisibleEvent>
  );
};
export default withSitecoreContext()(Table);
